
<template>
    <div class="signUp" :class="{'bodyfont-unauth': !user}">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <h2>
                        Gift Purchase
                    </h2>
                    <alert v-model="error.show" placement="top-right" duration="2000" type="danger" width="400px" dismissable>
                        <span class="icon-info-circled alert-icon-float-left"></span>
                        <strong>Error:</strong>
                        <p id="signup_errormsg">{{error.message}}</p>
                    </alert>
                    <div class="row margin-top">
                        <div class="col-md-8">
                            <div class="left-content">
                                <div class="panel panel-default text-left">

                                    <div class="row">
                                        <div class="col-sm-6">
                                            <div>
                                                <h4>
                                                    <span>1.</span> Gift Selection
                                                </h4>
                                            </div>
                                            <div class="panel-body">
                                                <br />
                                                <div class="gifts row" v-if="giftPlans">
                                                    <div class="col-sm-6"  v-for="plan in this.giftPlans">
                                                        <div class="gift-item">
                                                            <h5>
                                                                <input type="radio" name = "pkg" :value="plan.packageId" v-model="packageId" :checked="plan.packageId == packageId" /><br /><strong>Gift of TONE</strong>
                                                                <br /><small>{{plan.description}}</small>
                                                            </h5>
                                                            <button v-if="packageId !== plan.packageId" @click="packageId=plan.packageId">${{plan.amountFmt}}</button>
                                                            <button v-if="packageId === plan.packageId" class="active" @click="packageId=plan.packageId">${{plan.amountFmt}}</button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <br />
                                            </div>
                                        </div>
                                        <div class="col-sm-6">
                                            <div>
                                                <h4>
                                                    <span>2.</span>Gift Recipient
                                                </h4>
                                            </div>
                                            <form id="giftee_form" v-on:submit.prevent="addGiftee">
                                            <div class="panel-body" v-if="gifteeValidated">
                                                <br />
                                                <bs-input v-model="giftee.gifteeFirstName"
                                                          v-bind:pattern="/^[A-Za-z ]+$/"
                                                          id = "giftee_firstname"
                                                          type="text"
                                                          class="form-input"
                                                          error="First Name (no digits allowed)"
                                                          placeholder="First Name"
                                                          name="gifteeFirstName"
                                                          required
                                                          icon>
                                                </bs-input>
                                                <bs-input v-model="giftee.gifteeLastName"
                                                          v-bind:pattern="/^[A-Za-z ]+$/"
                                                          id = "giftee_lastname"
                                                          type="text"
                                                          class="form-input"
                                                          error="Last Name (no digits allowed)"
                                                          placeholder="Last Name"
                                                          name="gifteeLastName"
                                                          required
                                                          icon>
                                                </bs-input>
                                                <bs-input v-model="giftee.gifteeEmail"
                                                          v-bind:pattern="/\S+@\S+\.\S+/"
                                                          id = "giftee_email"
                                                          type="email"
                                                          class="form-input"
                                                          error="Email Address"
                                                          placeholder="Email Address"
                                                          name="gifteeEmail"
                                                          required
                                                          icon>
                                                </bs-input>
                                                <bs-input v-model="giftee.deliveryMessage"
                                                          id="giftee_comments"
                                                          type="textarea"
                                                          class="form-input"
                                                          error="Comments"
                                                          placeholder="Message"
                                                          name="gifteeDeliveryMessage"
                                                          required
                                                          icon>
                                                </bs-input>
                                                <label>Delivery Date</label>
                                                <!--<bs-input v-model="giftee.deliveryDate"-->
                                                          <!--id = "giftee_delivery"-->
                                                          <!--type="date"-->
                                                          <!--class="form-input"-->
                                                          <!--placeholder="Delivery Date"-->
                                                          <!--:error="dateErrorMessage"-->
                                                          <!--:min="returnMinimumDate()"-->
                                                          <!--data-date-format="mm/dd/yyyy"-->
                                                          <!--required-->
                                                          <!--icon>-->
                                                <!--</bs-input>-->
                                                <input name="gifteeDeliveryDate" required v-model="giftee.deliveryDate" class="form-control" id = "delivery" type="date" data-date-format="mm/dd/yyyy" :min="returnMinimumDate()" :title="dateErrorMessage" placeholder="Delivery Date"/>
                                                <button class="btn formButton btn-block" type="submit">
                                                    <i class="fa fa-shopping-cart" aria-hidden="true"></i>&nbsp;{{addMessage}}
                                                </button>
                                            </div>
                                            </form>
                                        </div>
                                        <div class="col-sm-12">
                                            <h4 v-if="gifteeCol.length > 0">Recipients</h4>
                                            <br />
                                            <div class="table-responsive">
                                            <table v-if="gifteeCol.length > 0">
                                                <thead>
                                                <tr>
                                                    <th>Recipient</th>
                                                    <th>Package</th>
                                                    <th>Message</th>
                                                    <th>Delivery Date</th>
                                                    <th>&nbsp;</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                <tr v-for="entry in gifteeCol">
                                                    <td>{{entry.gifteeFirstName}}&nbsp;{{entry.gifteeLastName}}<br>
                                                        {{entry.gifteeEmail}}
                                                    </td>
                                                    <td>{{getPackageInfo(entry.packageId)[0].description}}&nbsp;${{getPackageInfo(entry.packageId)[0].amount}}</td>
                                                    <td>{{entry.deliveryMessage}}</td>
                                                    <td>{{returnFormatedDate(entry.deliveryDate, 'A')}}</td>
                                                    <td><button class="btn formButton" @click="removeGiftee(entry)"><i class="fa fa-times"></i></button></td>
                                                </tr>
                                                </tbody>
                                            </table>
                                            </div>
                                            <div class="right-content" v-if="gifteeCol.length > 0">
                                                <div class="jumbotron text-center">
                                                    <p>Total Recipients : <b>{{gifteeCol.length}}</b> </p>
                                                    <p>Total Amount: <b>${{this.totalAmount}}</b></p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>

                        </div>
                        <div class="col-md-4">
                            <div class="left-content">
                                <accordion :one-at-atime="true">
                                    <panel :is-open="true"  class="text-left">
                                        <h4><span>3.</span> Your Information</h4>
                                        <!--<h4 v-if="paymentSection" slot="header" v-on:click="disablePaymentPanel; createSection = !createSection; paymentSection = false; isToggle = true">-->
                                        <!--<h4 v-if="paymentSection" slot="header">-->
                                        <!--1. CREATE AN ACCOUNT-->
                                        <!--<p class="sign-up-info"><b>Email: {{user.email}}</b></p>-->
                                        <!--</h4>-->
                                        <div class="create-account">
                                            <!--<p class="text-center">Fill out your information below.</p>-->
                                            <br>
                                            <div class="form">
                                                <form action="/charge" method="post" id="payment-form" v-on:submit.prevent="onPaymentSubmit">

                                                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12  padding-minus">
                                                        <div v-if="!user">
                                                            <bs-input v-model="gifter.firstName"
                                                                      v-bind:pattern="/^[A-Za-z ]+$/"
                                                                      id = "gifter_firstname"
                                                                      type="text"
                                                                      class="form-input"
                                                                      error="First Name (no digits allowed)"
                                                                      placeholder="First Name"
                                                                      name="gifterFirstName"
                                                                      required
                                                                      icon>
                                                            </bs-input>
                                                            <bs-input v-model="gifter.lastName"
                                                                      v-bind:pattern="/^[A-Za-z ]+$/"
                                                                      id = "gifter_lastname"
                                                                      type="text"
                                                                      class="form-input"
                                                                      error="Last Name (no digits allowed)"
                                                                      placeholder="Last Name"
                                                                      name="gifterLastName"
                                                                      required
                                                                      icon>
                                                            </bs-input>
                                                            <bs-input v-model="gifter.email"
                                                                      v-bind:pattern="/\S+@\S+\.\S+/"
                                                                      id = "gifter_email"
                                                                      type="email"
                                                                      class="form-input"
                                                                      error="Email Address"
                                                                      placeholder="Email Address"
                                                                      name="gifterEmail"
                                                                      required
                                                                      icon>
                                                            </bs-input>
                                                        </div>
                                                            <bs-input id="paymentMethod_cardHolder" v-if="gateway==='CC'"
                                                                      v-model = "gifter.cardHolderName"
                                                                      v-bind:pattern="/^[A-Za-z ]+$/"
                                                                      type="text"
                                                                      class="form-input"
                                                                      error="Card Holder Name (no digits allowed)"
                                                                      placeholder="Card Holder Name"
                                                                      name="gifterCardHolderName"
                                                                      required
                                                                      icon>
                                                            </bs-input>

                                                        <div class="radiowrapper">
                                                        </div>
                                                        <!--<div class="row">-->
                                                            <!--<div class="col-md-12">-->
                                                                <!--<div id="paypal-button" class="text-center margin-top-5 margin-bottom-10"></div>-->
                                                                <!--&lt;!&ndash;<div id="dropin-container"></div>&ndash;&gt;-->
                                                                <!--&lt;!&ndash;<button id="submit-button">Request payment method</button>&ndash;&gt;-->
                                                            <!--</div>-->
                                                        <!--</div>-->
                                                        <div CLASS="codediv">
                                                            <div class="stripeholder" v-if="isStripe">
                                                                <i class="fa fa-lock overlapstripe"></i>
                                                                <div id="card-element" class="field"></div>
                                                            </div>
                                                        </div>
                                                            <div class="row" v-if="gateway==='paypal'">
                                                                <div class="clearfix"></div>
                                                                <div class="col-md-12">
                                                                    <br>
                                                                    <div id="paypal-button" class="text-center margin-top-10 margin-bottom-10"></div>
                                                                    <!--<div id="dropin-container"></div>-->
                                                                    <!--<button id="submit-button">Request payment method</button>-->
                                                                </div>
                                                                <div style="margin-bottom: 10px" class="col-md-12" v-if="userPayments.paymentMethodNonce">
                                                                  <span  class="icon-info-circled alert-icon-float-left success">
                                                        <p class="alert alert-success alert-dismissable" ><i class="fa fa-check-square-o" aria-hidden="true"></i>Payment successfully authorized with Paypal</p>
                                                        </span>
                                                                </div>
                                                            </div>
                                                        <!-- Used to display form errors -->
                                                        <div v-if="stripeErrorMessage" role="alert" style="color:#a94442;margin:2px;">{{stripeErrorMessage}}</div>
                                                        <checkbox class="terms-and-condition" v-model="isChecked" value="isChecked" type="primary">
                                                            &nbsp;I agree to <a href="/terms" target="_blank">terms and conditions</a>
                                                            <!--I agree to-->
                                                            <!--<router-link  :to="{ path: '/terms'}" target="_new">-->
                                                                <!--terms and conditions-->
                                                            <!--</router-link>-->
                                                        </checkbox>
                                                    </div>
                                                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center padding-minus padding-minus-right">
                                                        <!--<button class="btn formButton btn-block" type="submit" id="signup_button" :disabled="isUserLoggedIn">-->
                                                        <button class="btn formButton btn-block" type="submit" id="signup_button"  :disabled = "!isChecked || this.spinner">
                                                            <i class="fa fa-paper-plane" aria-hidden="true"></i>&nbsp;Place Order
                                                            <spinner v-model="spinner" size="lg" class="btn-spinner"></spinner>
                                                        </button>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </panel>
                                </accordion>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import { input, spinner, accordion, panel, alert, dropdown, radio, checkbox, tabs, tab, buttonGroup, datepicker } from 'vue-strap'
    import VuePassword from 'vue-password'
    import $ from 'jquery'
    export default {
        components: {
            'bs-input': input,
            'spinner': spinner,
            'accordion': accordion,
            'panel': panel,
            alert,
            dropdown,
            radio,
            VuePassword,
            checkbox,
            tabs,
            tab,
            buttonGroup,
            datepicker
        },
        name: 'signUp',
        metaInfo () {
            return {
                title: 'TONE | Send Gifts',
                meta: [
                    {property: 'og:image', content: 'https://s3.amazonaws.com/tone-assets/images/TONEGiftingHolidays.jpg'},
                    {property: 'og:title', content: 'Give the Gift of Knowledge and Empowerment | TONE Networks'},
                    {property: 'og:site_name', content: 'The Perfect Holiday Gift for all the Women in Your Life'},
                    {
                        property: 'og:description',
                        content: 'Give the women in your life a subscription to TONE Networks, an empowering female community built around expert advice and support.'
                    },
                    {property: 'twitter:title', content: 'Give the Gift of Knowledge and Empowerment | TONE Networks'},
                    {property: 'twitter:card', content: 'summary'},
                    {property: 'twitter:image', content: 'https://s3.amazonaws.com/tone-assets/images/TONEGiftingHolidays.jpg'},
                    {
                        property: 'twitter:description',
                        content: 'Give the women in your life a subscription to TONE Networks, an empowering female community built around expert advice and support.'
                    },
                    {property: 'og:image:width', content: '300'},
                    {property: 'og:image:height', content: '300'}
                ]
            }
        },
        data: function () {
            return {
                gifter: {
                    userId: 0,
                    email: '',
                    firstName: '',
                    lastName: '',
                    cardHolderName: '',
                    stripeCustomerId: '',
                    packageId: '',
                    userPayments: [],
                    totalGiftedAmount: 0,
                    userGifts: ''
                },
                giftee: {
                    gifteeFirstName: '',
                    gifteeLastName: '',
                    gifteeEmail: '',
                    deliveryDate: '',
                    deliveryMessage: '',
                    redeemDate: null,
                    packageId: null
                },
                userPayments: {
                    token: '',
                    stripeCardId: '',
                    paymentType: 'CC',
                    paymentDate: new Date(),
                    paypalPayerId: '',
                    paypalPaymentId: '',
                    paymentMethodNonce: ''
                },
                gifteeValidated: true,
                spinner: false,
                alert: false,
                passwordError: '',
                confirmPassword: '',
                stripe: '',
                card: '',
                panelStatus: false,
                createSection: true,
                paymentSection: false,
                isToggle: false,
                defaultPlan: '',
                isChecked: false,
//                stripeKey: 'pk_test_SLHUyTkZmNS1OnLNdclgNldo',
                stripeKey: 'pk_test_SLHUyTkZmNS1OnLNdclgNldo',
                daysToCancel: 0,
                isStripe: true,
                gateway: 'CC',
                packageId: 0,
                gifteeCol: [],
                giftPlans: '',
                totalAmount: 0.00,
                minimumDate: new Date(),
                addMessage: 'Add Gift to Cart',
                dateErrorMessage: 'Delivery date must be ' + this.returnMinimumDate() + ' or later',
                dateFormat: 'mm/dd/yyyy',
                stripeErrorMessage: ''
            }
        },
        mounted () {
           // this.mountbraintree()
            this.$store.dispatch('GETPLANS').then(() => {
                this.packageId = this.getAllPlans[0].packageId
                this.giftPlans = this.getAllPlans.filter(pln => {
                    return (pln.type.toLowerCase().indexOf('gift') >= 0 && pln.packageId > 8)
                })
                if (this.getSelectedGiftId) {
                    this.packageId = this.getSelectedGiftId.giftId
                } else {
                    this.packageId = this.giftPlans[0].packageId
                }
            })
            if (this.user !== null) {
                if (this.user.firstName.length > 0) {
                    this.gifter.firstName = this.user.firstName
                    this.gifter.lastName = this.user.lastName
                    this.gifter.email = this.user.email
                    this.gifter.cardHolderName = `${this.user.firstName} ${this.user.lastName}`
                }
            }
            this.$store.dispatch('GETPAYPALTOKEN')
            this.mountStripeElement()
            $(':input').blur(function () {
                if ($(this).val().length > 0) {
                    // console.info('Send-Gift Page: Field.' + $(this).attr('name') + ', val: ' + $(this).val())
                    // console.log($(this).attr('name'), $(this).val())
                    window.logEvents('Send-Gift Page', 'Send-Gift Page: Field.' + $(this).attr('name'), 'Send-Gift Page: Field.' + $(this).attr('name') + ', val: ' + $(this).val())
                    // _gaq.push(['_trackEvent', 'INSERT FORM NAME HERE', 'completed', $(this).attr('name')])
                } else {
                   // console.info('Send-Gift Page: Field.' + $(this).attr('name') + ', val: ' + 'Skipped')
                    // console.log($(this).attr('name') + ' Skipped', '')
                    window.logEvents('Send-Gift Page', 'Send-Gift Page: Field.' + $(this).attr('name'), 'Send-Gift Page: Field.' + $(this).attr('name') + ', val: ' + 'skipped')
                    // _gaq.push(['_trackEvent', 'INSERT FORM NAME HERE', 'skipped', $(this).attr('name')])
                }
            })
            if (this.user) {
                window.juapp('arb', '[userId]', '[auth]')
            } else {
                window.juapp('arb', '[userId]', '[unauth]')
            }
        },
        methods: {
            togglePaymentMethods () {
                if (this.gateway === 'paypal') {
                    this.isStripe = false
                    setTimeout(() => {
                        this.mountbraintree()
                    }, 1000)
                } else {
                    this.isStripe = true
                    this.mountStripeElement()
                }
            },
            mountbraintree () {
                let self = this
                if (self.getPaypalToken) {
                    window.braintree.client.create({
                        authorization: 'production_6r7mxqgh_htw3nq9wp32w8h2x'
                    }, function (clientErr, clientInstance) {
                        // Stop if there was a problem creating the client.
                        // This could happen if there is a network error or if the authorization
                        // is invalid.
                        if (clientErr) {
                            console.error('Error creating client:', clientErr)
                            return
                        }
                        // Create a PayPal Checkout component.
                        window.braintree.paypalCheckout.create({
                            client: clientInstance
                        }, function (paypalCheckoutErr, paypalCheckoutInstance) {
                            // Stop if there was a problem creating PayPal Checkout.
                            // This could happen if there was a network error or if it's incorrectly
                            // configured.
                            if (paypalCheckoutErr) {
                                console.error('Error creating PayPal Checkout:', paypalCheckoutErr)
                                return
                            }
                            // Set up PayPal with the checkout.js library
                            window.paypal.Button.render({
                                env: 'production', // or 'sandbox'
                                payment: function () {
                                    return paypalCheckoutInstance.createPayment({
                                        flow: 'vault',
                                        amount: self.totalAmount || 19,
                                        currency: 'USD',
                                        intent: 'sale'
                                        // Your PayPal options here. For available options, see
                                        // http://braintree.github.io/braintree-web/current/PayPalCheckout.html#createPayment
                                    })
                                },
                                onAuthorize: function (data, actions) {
                                    return paypalCheckoutInstance.tokenizePayment(data)
                                        .then(function (payload) {
                                            // console.log('nonce', payload.nonce)
                                            // Submit `payload.nonce` to your server.
                                            self.userPayments.paymentMethodNonce = payload.nonce
                                        })
                                },
                                onCancel: function (data) {
                                    // console.log('checkout.js payment cancelled', JSON.stringify(data, 0, 2))
                                },
                                onError: function (err) {
                                    console.error('checkout.js error', err)
                                }
                            }, '#paypal-button').then(function () {
                                // The PayPal button will be rendered in an html element with the id
                                // `paypal-button`. This function will be called when the PayPal button
                                // is set up and ready to be used.
                            })
                        })
                    })
                }
            },
            spinnerToggle () {
                this.spinner = !this.spinner
            },
            resetForm () {
                setTimeout(() => {
                    this.gifteeValidated = !this.gifteeValidated
                }, 100)
            },
            mountStripeElement () {
                // let stripeKey = this.stripeKey
                setTimeout(() => {
                    this.stripe = window.Stripe(this.stripeKey)
                    const elements = this.stripe.elements()
                    this.card = elements.create('card')
                    this.card.mount('#card-element')
                }, 1000)
            },
            addGiftee () {
                if (this.verifyNameField(this.giftee.gifteeFirstName) && this.verifyNameField(this.giftee.gifteeLastName) && this.verifyEmailField(this.giftee.gifteeEmail)) {
                    let isDateValid = false
                    if (!this.doesEmailExists(this.giftee.gifteeEmail)) {
                        try {
                            let currentDate = new Date(this.returnMinimumDate())
                            currentDate.setHours(0)
                            currentDate.setMinutes(0)
//                            console.log('selected del date', this.giftee.deliveryDate)
//                            let delDate = new Date(this.giftee.deliveryDate + ' 00:00:00')
                            let delDate = new Date(this.giftee.deliveryDate.split('-').join('/'))
                           // delDate.setDate(delDate.getDate() + 1)
                            delDate.setHours(0)
                            delDate.setMinutes(0)
//                            console.log('current date', currentDate)
//                            console.log('del date', delDate)
                            if (delDate >= currentDate) {
//                        if (delDate.getDate() >= currentDate.getDate() && delDate.getMonth() + 1 >= currentDate.getMonth() + 1 && delDate.getFullYear() >= currentDate.getFullYear()) {
                                isDateValid = true
                            } else {
                                isDateValid = false
                                this.$swal({
                                    title: 'Invalid Delivery Date',
                                    text: '',
                                    type: 'error',
                                    timer: 2000,
                                    showCancelButton: false,
                                    showConfirmButton: false
                                }).then(
                                    function () {
                                    },
                                    // handling the promise rejection
                                    function (dismiss) {
                                        if (dismiss === 'timer') {
                                        }
                                    }
                                )
                            }
                        } catch (err) {
                            isDateValid = false
                            this.$swal({
                                title: '',
                                text: 'Invalid delivery date',
                                type: 'failure',
                                timer: 3000,
                                showCancelButton: false,
                                showConfirmButton: false
                            }).then(
                                function () {
                                },
                                // handling the promise rejection
                                function (dismiss) {
                                    if (dismiss === 'timer') {
                                    }
                                }
                            )
                        }
                        if (isDateValid) {
                            let newGiftee = {}
                            newGiftee.packageId = this.packageId
                            newGiftee.gifteeFirstName = this.giftee.gifteeFirstName
                            newGiftee.gifteeLastName = this.giftee.gifteeLastName
                            newGiftee.gifteeEmail = this.giftee.gifteeEmail.toLowerCase()
                            newGiftee.deliveryDate = this.returnFormatedDate(this.giftee.deliveryDate, 'M')
                            newGiftee.deliveryMessage = this.giftee.deliveryMessage
                            newGiftee.redeemDate = null
                            this.gifteeCol.push(newGiftee)
                            this.giftee.packageId = this.packageId
                            this.giftee.gifteeFirstName = ''
                            this.giftee.gifteeLastName = ''
                            this.giftee.gifteeEmail = ''
                            this.giftee.deliveryDate = this.returnMinimumDate()
                            this.giftee.deliveryMessage = ''
                            this.giftee.redeemDate = null
                            this.gifteeValidated = false
//                            console.log('col', this.gifteeCol)
                            this.resetForm()
                        }
                    } else {
                        this.$swal({
                            title: 'Recipient with this email already exists',
                            text: '',
                            type: 'error',
                            timer: 3000,
                            showCancelButton: false,
                            showConfirmButton: false
                        }).then(
                            function () {
                            },
                            // handling the promise rejection
                            function (dismiss) {
                                if (dismiss === 'timer') {
                                }
                            }
                        )
                    }
                }
            },
            removeGiftee (element) {
                const index = this.gifteeCol.indexOf(element)
                this.gifteeCol.splice(index, 1)
            },
            calculateTotalAmount () {
                this.totalAmount = 0
                if (this.gifteeCol && this.gifteeCol.length > 0) {
                    this.addMessage = 'Add Another Gift to Cart'
                    for (var i = 0; i < this.gifteeCol.length; i++) {
                        let packageInfo = this.getPackageInfo(this.gifteeCol[i].packageId)[0]
                        this.totalAmount = parseFloat(this.totalAmount) + parseFloat(packageInfo.amount)
                        this.totalAmount = parseFloat(this.totalAmount).toFixed(2)
                    }
                } else {
                    this.addMessage = 'Add Gift to Cart'
                }
            },
            getPackageInfo (packageId) {
                if (this.getAllPlans) {
                    let pkg = this.getAllPlans.filter(plan => {
                        return plan.packageId === packageId
                    })
                    return pkg
                }
                return null
            },
            verifyPaymentSubmit () {
                if (this.user.packageId > 0) {
                    return false
                }
                return true
            },
            verifyPasswordField (field) {
                if (field.length >= 8) {
                    let re = /^(?=.*?[A-Z])(?=(.*[a-z]){1,})(?=(.*[\d]){1,}).{8,}$/
                    if (!re.test(field)) {
                        this.passwordError = 'Min 8 Chars, One Upper Case, One Lower Case, One Digit!'
                        return false
                    } else {
                        return true
                    }
                } else {
                    if (field.length > 0) {
                        this.passwordError = 'Password must be of 8 charecters at least'
                        return false
                    } else {
                        return true
                    }
                }
            },
            verifyEmailField (field) {
                if (field.length > 0) {
                    let re = /\S+@\S+\.\S+/
                    if (!re.test(field)) {
                        return false
                    } else {
                        return true
                    }
                } else {
                    return false
                }
            },
//            verifyFirstName () {
//                if (this.user.firstName.length > 0) {
//                    let re = /^[A-Za-z ]+$/
//                    if (!re.test(this.user.firstName)) {
//                        return false
//                    } else {
//                        return true
//                    }
//                } else {
//                    return false
//                }
//            },
//            verifyLastName () {
//                if (this.user.lastName.length > 0) {
//                    let re = /^[A-Za-z ]+$/
//                    if (!re.test(this.user.lastName)) {
//                        return false
//                    } else {
//                        return true
//                    }
//                } else {
//                    return false
//                }
//            },
//            verifyCardHolderName () {
//                if (this.user.cardHolderName.length > 0) {
//                    let re = /^[A-Za-z ]+$/
//                    if (!re.test(this.user.cardHolderName)) {
//                        return false
//                    } else {
//                        return true
//                    }
//                } else {
//                    return false
//                }
//            },
            verifyNameField (field) {
                if (field.length > 0) {
                    let re = /^[A-Za-z ]+$/
                    if (!re.test(field)) {
                        return false
                    } else {
                        return true
                    }
                } else {
                    return false
                }
            },
            doesEmailExists (newEmail) {
                if (this.gifteeCol && this.gifteeCol.length > 0) {
                    let exists = this.gifteeCol.filter(giftee => {
                        return giftee.gifteeEmail.toLowerCase() === newEmail.toLowerCase()
                    })
                    if (exists && exists.length > 0) {
                        return true
                    }
                }
                return false
            },
            returnMinimumDate () {
                var today = new Date()
               // today.setDate(today.getDate() + 1)
                var dd = today.getDate()
                var mm = today.getMonth() + 1
                var yyyy = today.getFullYear()
                if (dd < 10) {
                    dd = '0' + dd
                }
                if (mm < 10) {
                    mm = '0' + mm
                }
                today = mm + '/' + dd + '/' + yyyy
                return today
            },
            returnFormatedDate (delDate, format) {
//                let ddate = new Date(delDate + ' 00:00:00')
                let ddate = new Date(delDate.split('-').join('/'))
               // ddate.setDate(ddate.getDate() + 1)
                let dd = ddate.getDate()
                let mm = ddate.getMonth() + 1
                let yyyy = ddate.getFullYear()
                if (dd < 10) {
                    dd = '0' + dd
                }
                if (mm < 10) {
                    mm = '0' + mm
                }
                if (format === 'M') {
                    return `${yyyy}-${mm}-${dd}`
                } else {
                    return `${mm}/${dd}/${yyyy}`
                }
            },
            onPaymentSubmit () {
             //   if (this.gifteeCol.length > 0) {
                let self = this
                if (this.verifyEmailField(this.gifter.email) && this.verifyNameField(this.gifter.firstName) && this.verifyNameField(this.gifter.lastName)) {
                    this.gifter.email = this.gifter.email.toLowerCase()
                    if (this.gifteeCol.length > 0) {
                        this.spinnerToggle()
                        if (this.gateway === 'CC') {
                            this.stripe.createToken(this.card).then((result) => {
                                if (result.error) {
                                    this.spinnerToggle()
                                    // Inform the user if there was an error
                                    // $(this.$el).find('#card-errors')
                                    // var errorElement = document.getElementById('card-errors')
                                    self.stripeErrorMessage = result.error.message
                                } else {
                                    // Send the token to your server
                                    const stripeToken = result.token.id
                                    const cardId = result.token.card.id
                                    this.userPayments.token = stripeToken
                                    this.userPayments.stripeCardId = cardId
                                    if (this.gifter.userPayments.length > 0) {
                                        this.gifter.userPayments.pop()
                                    }
                                    this.gifter.userPayments.push(this.userPayments)
                                    this.gifter.userGifts = this.gifteeCol
                                    this.gifter.totalGiftedAmount = this.totalAmount
                                    if (stripeToken) {
                                        this.$store.dispatch('ADDGIFTS', {gift: this.gifter}).then(() => {
                                            if (!this.error.show) {
                                                console.log('total amount', this.gifter.totalGiftedAmount)
                                                window.fbq('track', 'Purchase', {'value': this.gifter.totalGiftedAmount, 'currency': 'USD'})
                                                window.logEvents('form', 'submit', 'send-gift', this.gifter.totalGiftedAmount)
                                                // let sas = `https://shareasale.com/sale.cfm?amount=${this.totalAmount}&tracking=${self.user ? self.user.userId : 0}&transtype=GIFT&merchantID=76371`
                                                this.spinnerToggle()
                                                this.$router.push('/')
                                                this.$swal({
                                                    title: 'Gifts Sent!' + '<img height="1" width="1" style="display:none;" alt="" src="https://px.ads.linkedin.com/collect/?pid=565489&conversionId=1609346&fmt=gif" />',
                                                    text: '',
                                                    type: 'success',
                                                    timer: 4000,
                                                    showCancelButton: false,
                                                    showConfirmButton: false
                                                }).then(
                                                    function () {
                                                    },
                                                    // handling the promise rejection
                                                    function (dismiss) {
                                                        if (dismiss === 'timer') {
                                                        }
                                                    }
                                                )
                                            } else {
                                                this.spinnerToggle()
                                            }
                                        })
                                    }
                                }
                            })
                        } else if (this.userPayments.paymentMethodNonce) {
                            if (this.gifter.userPayments.length > 0) {
                                this.gifter.userPayments.pop()
                            }
                            this.gifter.userPayments.push(this.userPayments)
                            this.gifter.userGifts = this.gifteeCol
                            this.gifter.totalGiftedAmount = this.totalAmount
                            this.$store.dispatch('ADDGIFTS', {gift: this.gifter}).then(() => {
                                if (!this.error.show) {
                                    this.spinnerToggle()
                                    window.fbq('track', 'Purchase', {value: this.gifter.totalGiftedAmount, currency: 'USD'})
                                    window.logEvents('form', 'submit', 'send-gift', this.gifter.totalGiftedAmount)
                                    this.$router.push('/')
                                    this.$swal({
                                        title: 'Gifts Sent!' + '<img height="1" width="1" style="display:none;" alt="" src="https://px.ads.linkedin.com/collect/?pid=565489&conversionId=1609346&fmt=gif" />',
                                        text: '',
                                        type: 'success',
                                        timer: 4000,
                                        showCancelButton: false,
                                        showConfirmButton: false
                                    }).then(
                                        function () {
                                        },
                                        // handling the promise rejection
                                        function (dismiss) {
                                            if (dismiss === 'timer') {
                                            }
                                        }
                                    )
                                } else {
                                    this.spinnerToggle()
                                }
                            })
                        } else {
                            this.spinnerToggle()
                        }
                    } else {
                        this.$swal({
                            title: 'Add Gift to Cart',
                            text: '',
                            type: 'error',
                            timer: 2000,
                            showCancelButton: false,
                            showConfirmButton: false
                        }).then(
                            function () {
                            },
                            // handling the promise rejection
                            function (dismiss) {
                                if (dismiss === 'timer') {
                                }
                            }
                        )
                    }
                }
            }
        },
        computed: {...mapGetters([
            'error', 'user', 'isUserLoggedIn', 'getDefaultPlan', 'getAllPlans', 'user', 'getSelectedGiftId', 'getPaypalToken'])
        },
        watch: {
            'gifter.firstName' (to, from) {
                this.gifter.cardHolderName = `${this.gifter.firstName} ${this.gifter.lastName}`
            },
            'gifter.lastName' (to, from) {
                this.gifter.cardHolderName = `${this.gifter.firstName} ${this.gifter.lastName}`
            },
            'gifteeCol' (to, from) {
                this.calculateTotalAmount()
            },
            'gateway' (to, from) {
                if (this.gateway === 'paypal') {
                    this.card.unmount('#card-element')
                    this.stripeErrorMessage = ''
                    this.isStripe = false
                    this.userPayments.token = ''
                    this.userPayments.paypalPayerId = ''
                    this.userPayments.paypalPaymentId = ''
                    this.userPayments.stripeCardId = ''
                    this.userPayments.paymentType = 'PayPal'
//                    this.user.isPaypalCustomer = '1'
                    this.userPayments.paymentMethodNonce = ''
                    setTimeout(() => {
                        this.mountbraintree()
                    }, 1000)
                } else {
                    this.stripeErrorMessage = ''
                    this.userPayments.token = ''
                    this.userPayments.paypalPayerId = ''
                    this.userPayments.paypalPaymentId = ''
                    this.userPayments.stripeCardId = ''
//                    this.user.isPaypalCustomer = '0'
                    this.userPayments.paymentType = 'CC'
                    this.userPayments.paymentMethodNonce = ''
                    this.isStripe = true
                    setTimeout(() => {
                        this.mountStripeElement()
                    }, 1000)
                }
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .stripeholder {
        position: relative;
    }
    i.fa.fa-lock.overlapstripe {
        position: absolute;
        left: 18px;
        top: 10px;
        font-size: 18px;
        color: #b2b8c7;
    }
    .codediv {
        padding: 10px 0 0;
    }
    .codediv + .row.code {
        padding-top: 0;
    }

    .stripeholder {}

    .codediv .stripeholder {
        margin-bottom: 20px;
    }

    .codediv .col-md-12 {
        min-height: 0;
    }
    .StripeElement {
        background-color: white;
        padding: 2em 1em;
        border: 1px solid #ccc;
        box-shadow: 0 1px 3px 0 #e6ebf1;
        -webkit-transition: box-shadow 150ms ease;
        transition: box-shadow 150ms ease;
        height: 34px;
    }
    .float-right.paymentswitch.btn-group {
        margin: 0 0 30px;
    }
    .StripeElement--focus {
        box-shadow: 0 1px 3px 0 #cfd7df;
    }

    .StripeElement--invalid {
        border-color: #fa755a;
    }

    .StripeElement--webkit-autofill {
        background-color: #fefde5 !important;
    }
    .radiowrapper {
        padding: 0px;
        color: #f0617d;
    }
    /* Media query for mobile viewport*/
    @media screen and (max-width: 400px) {
        #paypal-button-container {
            width: 100%;
        }
    }

    /*Media query for desktop viewport */
    @media screen and (min-width: 400px) {
        #paypal-button-container {
            width: 250px;
            display: inline-block;
        }
    }
    table {
        font-size: 12px;
        letter-spacing: 0;
        width:100%;
    }

    table td {
        text-align: left;
        padding: 12px;
    }

    table th {
        text-align: left;
        padding: 12px;
        background: #f0617d;
        color:#fff;
    }

    h2 {
        color: #f0617d;
        text-transform: capitalize;
        margin: 45px 0 0;
        letter-spacing: 0.5px;
        font-family: sans-serif;
        text-align:center;
    }
    tr {
        border-bottom: 1px solid #ddd;
    }
    li.list-group-item {
        float: left;
        width: 48%;
        padding: 5px;
        margin: 40px 1% 30px;
        background-size: 100px !important;
        border-radius: 0 !important;
        height: auto;
        background-color: #f9f9f9;
        padding-top: 60px;
    }
    li.list-group-item:before {
        background-image: url(../assets/Gift-Ribbon-PNG-Photos.png) !important;
        float: left;
        width: 100%;
        padding: 2%;
        background-size: contain !important;
        border-radius: 0 !important;
        background-color: transparent;
        background-repeat: no-repeat;
        background-position: center top;
        border: 0 none transparent;
        content: "";
        position: absolute;
        top: -43px;
        height: 100px;
    }

    li h5 {letter-spacing: 1px;text-align: center;}
    .row.margin-top {
        margin-bottom: 80px;
    }
    .signUp .right-content .jumbotron {
        padding: 10px;
    }
    .signUp .left-content .panel-body .form-group {
        margin-bottom: 10px;
    }

    /*gift section classes*/
    .gift-item:before {
        background: url(../assets/img_33997.png);
        content:"";
        height: 150px;
        display: block;
    position: absolute;
        background-position: center !important;
        background-repeat: no-repeat !important;
        transform: translateY(-50%);
    top: 0;
        right: 0;
        left: 0;
    }

    .gift-item {
        background: #54d9ec;
        color: #fff;
        margin: 120px 0 0;
        padding: 80px 20px 20px;
        position: relative;
        text-align: center;
    }

    .gift-item h5 {
        font-size: 22px;
    }

    .gift-item h5 small {
        color: #fff;
    }
    .gift-item button {
        background: #0eb4ce;
        border: 2px solid #13a8bf;
        padding: 10px 25px;
        margin: 10px 0;
    }

    .gifts.row {
        margin-bottom: 50px;
    }
    button.active {
        outline: 1px solid blue;
    }
    div#paypal-button {
        /*text-align: left;*/
        margin: 0 12px !important;
        position: relative;
        top: -8px;
    }
    @media(min-width:768px){

        .col-md-8 .col-sm-6 .gift-item {
            padding: 40px 10px 10px;
            margin: 50px 0 10px;
        }

        .col-md-8 .col-sm-6 .gift-item h5 {
            font-size: 16px;
        }

        .col-md-8 .col-sm-6 .gift-item:before {
            height: 80px;
            background-size: contain;
        }

        .col-md-8 .col-sm-6 .gift-item button {
            padding: 5px;
        }
    }
    @media(min-width:320px) and (max-width:375px){
        /*table  tr  td:nth-child(2) , table  tr  th:nth-child(2) {*/
            /*display: none;*/
        /*}*/

        /*table  tr  td:nth-child(3) , table  tr  th:nth-child(3) {*/
            /*display: none;*/
        /*}*/
    }

    @media(min-width:376px) and (max-width:425px){

        /*table  tr  td:nth-child(3) , table  tr  th:nth-child(3) {*/
            /*display: none;*/
        /*}*/
    }
    @media(min-width: 320px) and (max-width: 767px){
        table  tr  th{
            white-space: nowrap;
            font-size: 14px;
        }
        table  tr  td{
            white-space: nowrap;
            font-size: 14px;
        }
    }

</style>



// WEBPACK FOOTER //
// Gift.vue?53a2b3b4